import React, { Component } from 'react';
import Emoticon from './Emoticon';
import Activities from './Activities';

import './App.css';

class App extends Component {
  render() {
    return (
		<div className='container-fluid'>
			<Emoticon />
			<Activities />
		</div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js